var Backbone = bookedby.deps != null ? bookedby.deps.Backbone : global.Backbone;

var ServiceModel = Backbone.Epoxy.Model.extend({
  defaults: {
    active: true,
    hasPrice: false,
    minPrice: null,
    maxPrice: null,
    minDuration: null,
    maxDuration: null,
    hasDurations: null
  }
});

module.exports = ServiceModel;